import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    email: null,
    projectName: null,
    projectId: null,
    organizationName: null,
    roleId: null,
  },
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload;
    },

    setProjectDetails: (state, action) => {
      state.projectName = action.payload.projectName;
      state.projectId = action.payload.projectId;
      state.organizationName = action.payload.organizationName;
      state.roleId = action.payload.roleId || null;
    },

    setRoleId: (state, action) => {
      state.roleId = action.payload;
    },
  },
});

export const { setEmail, setProjectDetails, setRoleId } = userSlice.actions;
export default userSlice.reducer;